import { Model } from '../model';
import { Paginated } from '../paginated';
import * as moment from 'moment';
import { Moment } from 'moment';

export class ShopItem extends Model {
  idShopItem?: string;
  category: string;
  label: string;
  price: string | number;
  unitPrice: string;
}

export class CartItem extends Model {
  idShopCartItem?: number;
  isUpgrade: boolean;
  maxQuantity: number;
  quantity: number;
  shopItem: ShopItem;
  totalPriceItem?: string;
  idUser: number;
}

export class Cart extends Model {
  createDate: Moment;
  idInvoice: number;
  idShoppingCart: number;
  invoiced: boolean;
  cigCode?: string;
  discountCode?: string;
  discountPrice?: string;
  lastModifyDate: Moment;
  paymentMethod: string;
  status: number;
  totalPrice: string | number;
  totalPriceToPay: string | number;
  vat: string | number;
  vatPercent: string | number;
  shopCartItems: Array<CartItem>;
  discountBonusSms?: Array<any>;

  afterDeserialize(input: any) {
    if (this.createDate) {
      this.createDate = moment(this.createDate);
    }
    if (this.lastModifyDate) {
      this.lastModifyDate = moment(this.lastModifyDate);
    }
    // if (typeof this.totalPrice === 'string') {
    //   this.totalPrice = parseFloat(this.totalPrice);
    // }
    // if (typeof this.totalPriceToPay === 'string') {
    //   this.totalPriceToPay = parseFloat(this.totalPriceToPay);
    //   // this.totalPriceToPay = parseFloat(this.totalPriceToPay.replace(',', '.'));
    // }
    // if (typeof this.vat === 'string') {
    //   this.vat = parseFloat(this.vat);
    // }
    // if (typeof this.vatPercent === 'string') {
    //   this.vatPercent = parseFloat(this.vatPercent);
    // }
    //   if (this.shopCartItems) {
    //     this.shopCartItems.map(cartItem => {
    //       if (cartItem.shopItem) {
    //         let price = cartItem.shopItem.price;
    //         if (typeof price === 'string') {
    //           // cartItem.shopItem.price = parseFloat(cartItem.shopItem.price);
    //           price = parseFloat(price);
    //         }
    //         cartItem.totalPrice = cartItem.shopItem.price ? cartItem.quantity * price : 0;
    //       }
    //     });
    //   }
  }
}

export class Carts extends Paginated {
  data: Array<Cart>;
}
